import axios from 'axios';

export default {
	pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_liquidadores.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	recuperar(p_email, p_usuario, p_slicodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_liquidadores.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_slicodigo": p_slicodigo,
					"p_tiporec": p_tiporec
				  })
			})
    },

    eliminar(p_email, p_usuario, p_slicodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_liquidadores.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_slicodigo": p_slicodigo
				  })
			})
	},

	activar(p_email, p_usuario, p_slicodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_liquidadores.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_slicodigo": p_slicodigo
				  })
			})
	},

}